import script from "./pp-kasicka-winnings.vue?vue&type=script&lang=ts&setup=true"
export * from "./pp-kasicka-winnings.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__